import React from 'react';

const BreedHeading: React.FC = ({ children }) => {
  return (
    <h3 className="puppy-head text-center">
      {children}
    </h3>
  );
};

export default BreedHeading;
